import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import PerButton from '../../../../components/custom_components/Button'

import PerFlexRow from '../../../../components/custom_components/FlexRow'
import PerSpacer from '../../../../components/custom_components/Spacer'
import PerText from '../../../../components/custom_components/Text'
import useCompanyRankingSettingsMutations from '../../../../graphql/company-ranking-settings/hooks/useCompanyRankingSettingsMutations'
import { Country } from '../../../../types'

interface ICompanySettingsRankingTopTagProcessModalFooterProps {
  companyId: string
  country: Country
  toggleModal: (value: boolean) => void
}

export const CompanySettingsRankingTopTagProcessModalFooter: FC<ICompanySettingsRankingTopTagProcessModalFooterProps> = ({
  companyId,
  country,
  toggleModal,
}) => {
  const { t } = useTranslation()
  const [isProcessing, toggleProcessing] = useState<boolean>(false)
  const [errorMessage, setErrorMessage] = useState<string>('')

  const { enableRankingChanges } = useCompanyRankingSettingsMutations(companyId, country)

  const handleSubmit = async () => {
    setErrorMessage('')
    toggleProcessing(true)

    const { errors } = await enableRankingChanges()
    if (!!errors) {
      setErrorMessage(t('companySettingsView.rankingTab.modal.error'))
      toggleProcessing(false)
    } else {
      toggleModal(false)
    }
  }

  return (
    <PerFlexRow align="middle" justify="space-between">
      <PerButton
        text={t('global.button.cancel')}
        color="secondary"
        before="close_stroke"
        variant="pastel"
        type="button"
        onClick={() => toggleModal(false)}
      />
      <PerFlexRow align="middle">
        {!!errorMessage && (
          <PerText appearance="info" color="error">
            {errorMessage}
          </PerText>
        )}
        <PerSpacer ml="xxxs" mr="xxxs" />
        <PerButton
          text={t('global.button.confirm')}
          color="success"
          before="check_stroke"
          variant="pastel"
          type="button"
          isProcessing={{ active: isProcessing }}
          onClick={handleSubmit}
        />
      </PerFlexRow>
    </PerFlexRow>
  )
}
